import { FC } from "react";
import { Assurance } from "../../lib/interfaces/assurance.interface";
import { formatDate } from "../../lib/helpers/date_helpers";
import { MoreVertical } from "lucide-react";
import { Button } from "../ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

interface Props {
  assurance: Assurance;
}

const AssuranceItem: FC<Props> = ({ assurance }) => {
  return (
    <div className="border-l-2 border-indigo-900 pl-4 flex flex-row gap-4 items-center">
      <div className="flex-1">
        <div className="font-semibold">
          {assurance.typeAssurance?.description}
        </div>
        <div className="mt-0.5">
          Du {formatDate(assurance.dateDebut)} au{" "}
          {formatDate(assurance.dateFin)} pour{" "}
          <strong>{assurance.ruches}</strong> ruche(s)
        </div>
      </div>
      <div>
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button className="text-slate-500" variant={"ghost"} size={"icon"}>
              <MoreVertical />
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent>
            <DropdownMenuLabel>Documents Groupama</DropdownMenuLabel>
            <DropdownMenuSeparator />
            <DropdownMenuItem>
              <a
                href="https://www.snapiculture.com/wp-content/uploads/2023/11/conditions-generales-assurances-apicoles-SNA-2024.pdf"
                target="_blank"
              >
                Conditions générales
              </a>
            </DropdownMenuItem>
            <DropdownMenuItem>
              <a
                href="https://www.snapiculture.com/wp-content/uploads/2023/11/franchises-sna-2024.pdf"
                target="_blank"
              >
                Franchises et garanties
              </a>
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
    </div>
  );
};

export default AssuranceItem;
